'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.prefetchMeetingData = prefetchMeetingData;
exports.getInlineMeetingParams = getInlineMeetingParams;

var _params = require('hub-http/helpers/params');

var _getUserInfo = require('ui-addon-upgrades/_core/common/api/getUserInfo');

var linkParams = void 0;
var BASE_PARAMS = {
  embed: true
};

function prefetchMeetingData() {
  (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var user = _ref.user,
        portal = _ref.portal;

    linkParams = {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      website: portal.domain
    };
  }).catch(function () {
    linkParams = {
      firstName: null,
      lastName: null,
      email: null,
      website: null
    };
  });
}

function getInlineMeetingParams(upgradeData) {
  var hasAssignedRep = !!(upgradeData.repInfo && upgradeData.repInfo.link);
  var attributionSource = hasAssignedRep ? 'rep' : 'ISC';
  var meetingParams = {
    meeting_funnel: 'in-app',
    meeting_medium: 'pql',
    meeting_product: upgradeData.upgradeProduct,
    meeting_source: upgradeData.source,
    meeting_type: attributionSource,
    meeting_campaign: attributionSource
  };

  return (0, _params.stringify)(_extends({}, linkParams, meetingParams, BASE_PARAMS));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/api/meetingHelpers.js
// module id = 205
// module chunks = 3 4 5